

























import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class RptSalesSummary extends Vue {

  // 売上集計用プロパティ
  public reportTemplate: Common.ReportTemplate = null;
  public startDate: Date = null;
  public endDate: Date = null;
  public segment: Common.Segment = null;
  public counterpart: Common.Counterpart = null;
  public counterpartCategory: Common.Category = null;
  public categoryGroupCounterpart: Common.CategoryGroup = Common.CategoryGroup.Counterpart;
  public commodity: Common.Commodity = null;
  public commodityCategory: Common.Category = null;
  public categoryGroupCommodity: Common.CategoryGroup = Common.CategoryGroup.Commodity;
  public sort: number = 0;
  public itemCategory: number = null;
  public summaryCategory1: number = null;
  public summaryCategory2: number = null;
  // public includeProspect: boolean = false;
  public onExcelExport :boolean = false;
  public startDateFlag : Common.dateFlags = Common.dateFlags.default;
  public endDateFlag : Common.dateFlags = Common.dateFlags.default;  
  public searchDeliveryDate: boolean = false;
  public includeProspectType: Common.IncludeProspectTypes = Common.IncludeProspectTypes.None;
  public mounted(){
   if ((this.$parent as any).favoriteLoaded == false){     
    var query: Common.SalesSummaryReportTemplateQuery = new Common.SalesSummaryReportTemplateQuery();
    this.$api.execute(query).then(obj => {
      var items: Common.ReportTemplate[] = new Array();
      items = (obj as Common.LoadResult).result;
      if (items.length > 0) this.reportTemplate = items[0];
    });
   }
    var today = new Date();
    this.startDate = new Date(today.getFullYear(),today.getMonth(),1).getCalendarDate();
    this.endDate = new Date(today.getFullYear(),today.getMonth() +1,0).getCalendarDate();
    (this.$refs.SalesSummaryDialog as Components.ListDialog).showDialog();
  }
  public async onReportGenerate(){
    var query: Common.SalesSummaryReportQuery = new Common.SalesSummaryReportQuery();

    // クエリの設定
    query.templateId = this.reportTemplate.id;
    query.startDate = this.startDate;
    query.endDate = this.endDate;
    query.segment = this.segment;
    query.counterpart = this.counterpart;
    query.counterpartCategory = this.counterpartCategory;
    query.commodity = this.commodity;
    query.commodityCategory = this.commodityCategory;
    query.sort = this.sort;
    query.itemCategory = this.itemCategory;
    if (this.summaryCategory1 == null) query.summaryCategory1 = 0;
    else query.summaryCategory1 = this.summaryCategory1;
    if (this.summaryCategory2 == null) query.summaryCategory2 = 0;
    else query.summaryCategory2 = this.summaryCategory2;
    // query.includeProspect = this.includeProspect;
    query.onExcelExport = this.onExcelExport;
    query.searchDeliveryDate = this.searchDeliveryDate;
    query.includeProspectType = this.includeProspectType;
    this.$api.download(query);
  }
}
